module.exports = __webpack_public_path__ + "img/2000_5e33d0b98abba.3dc803bf.png";